module.exports = __webpack_public_path__ + "img/fh_code_6.7656b6fb.png";